export const CHECKBOX = 'CHECKBOX';
export const RADIO = 'RADIO';
export const DROPDOWN = 'DROPDOWN';
export const DATE_RANGE = 'DATE_RANGE';
export const DATE = 'DATE';
export const MULTI_SEARCH = 'MULTI_SEARCH';
export const TAGS = 'TAGS';
export const TOGGLE = 'TOGGLE';


export const ADVANCED_FILTER_TYPES = {
  CHECKBOX,
  RADIO,
  DROPDOWN,
  DATE_RANGE,
  DATE,
  MULTI_SEARCH,
  TAGS,
  TOGGLE
};